var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 30.5,
    stroke: "#0087B7",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0332 36.9414L19.5297 31.1286L16.9746 33.7565L27.0332 44.1752L48.6043 22.365L46.8725 19.8254L27.0332 36.9414Z",
    fill: "#0087B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitSuccess);
export default __webpack_public_path__ + "static/media/submitSuccess.379f15ddae8c4dc27700f033529a4391.svg";
export { ForwardRef as ReactComponent };